import type { PlatformSyncHealth } from '@order-pilot/shared';
import { api, queryString } from '@/lib/api';

/** Minutes without contact after which a till is flagged. Matches the API default. */
export const DEFAULT_STALE_MINUTES = 60;

export const STALE_OPTIONS: ReadonlyArray<{ value: number; label: string }> = [
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' },
  { value: 180, label: '3 hours' },
  { value: 1440, label: '24 hours' },
];

export const syncHealthKeys = {
  all: ['sync-health'] as const,
  platform: (staleMinutes: number) => ['sync-health', 'platform', staleMinutes] as const,
};

export function fetchPlatformSyncHealth(
  staleMinutes: number,
  signal?: AbortSignal,
): Promise<PlatformSyncHealth> {
  return api.get<PlatformSyncHealth>(
    `/admin/sync-health${queryString({ stale: staleMinutes })}`,
    { signal },
  );
}
